// GLSL shader（由 .fs 迁移为 TS 模块）
export default /* glsl */ `// #extension GL_EXT_frag_depth : enable

//
// adapted from the EDL shader code from Christian Boucheny in cloud compare:
// https://github.com/cloudcompare/trunk/tree/master/plugins/qEDL/shaders/EDL
//

precision highp float;
precision mediump int;

uniform highp sampler2D uWeightMap;
uniform highp sampler2D uEDLMap;
uniform highp sampler2D uDepthMap;

uniform float screenWidth;
uniform float screenHeight;
uniform vec2 neighbours[NEIGHBOUR_COUNT];
uniform float edlStrength;
uniform float radius;
uniform float opacity;

in vec2 vUv;
out vec4 pc_fragColor;

bool isBackground(float sceneDepth){
	return sceneDepth >= 1.0;
}

float response(float depth){
	vec2 uvRadius = radius / vec2(screenWidth, screenHeight);
	
	float sum = 0.0;
	
	for(int i = 0; i < NEIGHBOUR_COUNT; i++){
		vec2 uvNeighbor = vUv + uvRadius * neighbours[i];
		float neighbourSceneDepth = texture(uDepthMap, uvNeighbor).r;
		if(isBackground(neighbourSceneDepth)){
			continue;
		}
		float neighbourDepth = texture(uEDLMap, uvNeighbor).a;
		sum += max(0.0, depth - neighbourDepth);
	}
	
	return sum / float(NEIGHBOUR_COUNT);
}

void main() {
	float depth = texture(uDepthMap, vUv).r;
	if(isBackground(depth)){
		discard;
	}

	vec4 color = texture(uWeightMap, vUv);
	if(color.w <= 0.0){
		discard;
	}

	float edlDepth = texture(uEDLMap, vUv).a;
	float res = response(edlDepth);
	float shade = exp(-res * 300.0 * edlStrength);

	color = color / color.w;
	color = color * shade;

	pc_fragColor = vec4(color.xyz, opacity);

	gl_FragDepth = depth;
}`;
